import { inventoryReportService } from '../../services';

export const config: any = {
  getServiceResourceCost: (params: any) =>
    inventoryReportService.getServiceResourceCost(params),
  getServiceWiseCost: (params: any) =>
    inventoryReportService.getServiceWiseCost(params),
  getServiceReportCsv: (params: any) =>
    inventoryReportService.getServiceReportCsv(params),
  getBillingSummary: (params: any) =>
    inventoryReportService.getBillingSummary(params),
  getBillingStatistics: (params: any) =>
    inventoryReportService.getGridSummaryData(params),
};
export const awsRegions = [
  'us-east-1',
  'us-east-2',
  'us-west-1',
  'us-west-2',
  'ca-central-1',
  'eu-central-1',
  'eu-west-1',
  'eu-west-2',
  'eu-west-3',
  'eu-north-1',
  'eu-south-1',
  'ap-east-1',
  'ap-south-1',
  'ap-northeast-1',
  'ap-northeast-2',
  'ap-northeast-3',
  'ap-southeast-1',
  'ap-southeast-2',
  'sa-east-1',
  'me-south-1',
];

export const azureLocations = [
  'DE West Central',
  'Central India',
  // 'East US',
  'IN South',
  'centralindia',
  // 'WESTUS',
  'US West 2',
  'Intercontinental',
  // 'West US',
  'Asia',
  'US West Central',
  // 'Unknown',
  'US South Central',
  'US Central',
  'IN Central',
  'US North Central',
  'US East',
  'westus',
  'US West',
  // 'eastus',
  'northeurope',
  'US East 2',
  'CENTRALINDIA',
  'NORTHEUROPE',
  // 'EASTUS',
];

//   [
//   'Central US',
//   'East US',
//   'East US 2',
//   'North Central US',
//   'South Central US',
//   'West Central US',
//   'West US',
//   'West US 2',
//   'West US 3',
//   'South Africa North',
//   'East Asia',
//   'Southeast Asia',
//   'Australia Central',
//   'Australia East',
//   'Australia Southeast',
//   'Brazil South',
//   'Canada Central',
//   'Canada East',
//   'China Non-Regional',
//   'China East',
//   'China East 2',
//   'China North',
//   'China North 2',
//   'China North 3',
//   'North Europe',
//   'West Europe',
//   'France Central',
//   'Germany West Central',
//   'Central India',
//   'South India',
//   'Israel Central',
//   'Italy North',
//   'Japan East',
//   'Japan West',
//   'Korea Central',
//   'Norway East',
//   'Poland Central',
//   'Qatar Central',
//   'Sweden Central',
//   'Switzerland North',
//   'UAE North',
//   'UK South',
//   'UK West',
// ];

export const customColors = [
  '#d04d6d',
  '#7ee38b',
  '#ffe119',
  '#8298e5',
  '#f58231',
  '#b85ed3',
  '#46f0f0',
  '#e17ddc',
  '#bcf60c',
  '#fabebe',
  '#4bd3d3',
  '#e6beff',
  '#ce9e67',
  '#fffac8',
  '#b04646',
  '#aaffc3',
  '#808000',
  '#ffd8b1',
  '#4040a4',
  '#808080',
  '#664b4b',
  '#201f1f',
  '#3A66A3',
  '#FFD700',
  '#4a954a',
  '#f4a341',
  '#8e49bf',
  '#9370DB',
  '#6A5ACD',
  '#20B2AA',
  '#87CEFA',
  '#00FA9A',
  '#a25ae6',
  '#00FF00',
  '#f67a64',
  '#4682B4',
  '#FF4500',
  '#ADFF2F',
  '#D2691E',
  '#00CED1',
];

// utils/summaryDataUtils.ts

export interface ApiSummaryData {
  prevMonthCost: number;
  curMonthCost: number;
  forecast: number;
  dailyAverage: number;
}

export interface SummaryItem {
  title: string;
  description: string;
  value: string;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
  icon: 'calendar' | 'chart' | 'forecast' | 'average';
}

// Format currency with proper commas and currency symbol
const formatCurrency = (amount: number, currency: string = '$'): string => {
  return `${currency}${Math.abs(amount).toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
};

// Calculate percentage change between two values
// const calculatePercentageChange = (
//   current: number,
//   previous: number
// ): number => {
//   if (previous === 0) return 0;
//   return ((current - previous) / Math.abs(previous)) * 100;
// };

// // Determine trend based on percentage change
// const getTrend = (percentageChange: number): 'up' | 'down' | 'neutral' => {
//   if (percentageChange > 1) return 'up';
//   if (percentageChange < -1) return 'down';
//   return 'neutral';
// };

// Get current and previous month names
const getCurrentAndPreviousMonth = () => {
  const now = new Date();
  const currentMonth = now.toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
  });

  const prevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const previousMonth = prevMonth.toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
  });

  return { currentMonth, previousMonth };
};

// Generate error/fallback summary data when API fails
export const getErrorSummaryData = (): SummaryItem[] => {
  const { currentMonth, previousMonth } = getCurrentAndPreviousMonth();

  return [
    {
      title: 'Past Month',
      description: previousMonth,
      value: 'N/A',
      // trend: 'neutral',
      icon: 'calendar',
    },
    {
      title: 'Current Month',
      description: currentMonth,
      value: 'N/A',
      // trend: 'neutral',
      icon: 'chart',
    },
    {
      title: 'Forecast',
      description: '',
      value: 'N/A',
      // trend: 'neutral',
      icon: 'forecast',
    },
    {
      title: 'Daily Average',
      description: '',
      value: 'N/A',
      // trend: 'neutral',
      icon: 'average',
    },
  ];
};

// Convert API data to summary grid format
export const convertToSummaryData = (
  apiData: ApiSummaryData | null,
  currency: string = '$'
): SummaryItem[] => {
  if (!apiData) {
    return getErrorSummaryData();
  }

  const { currentMonth, previousMonth } = getCurrentAndPreviousMonth();

  // // Calculate percentage changes
  // const currentVsPrevPercentage = calculatePercentageChange(
  //   apiData.curMonthCost,
  //   apiData.prevMonthCost
  // );

  // const forecastVsCurrentPercentage = calculatePercentageChange(
  //   apiData.forecast,
  //   apiData.curMonthCost
  // );

  // // Calculate average change (you can modify this logic as needed)
  // const avgChangePercentage = calculatePercentageChange(
  //   apiData.dailyAverage,
  //   apiData.prevMonthCost / 30 // Assuming 30 days in previous month
  // );

  return [
    {
      title: 'Past Month',
      description: previousMonth,
      value: formatCurrency(apiData.prevMonthCost, currency),
      // trend: 'neutral',
      icon: 'calendar',
    },
    {
      title: 'Current Month',
      description: currentMonth,
      value: formatCurrency(apiData.curMonthCost, currency),
      // trend: getTrend(currentVsPrevPercentage),
      // trendValue: `${Math.abs(currentVsPrevPercentage).toFixed(1)}%`,
      icon: 'chart',
    },
    {
      title: 'Forecast',
      description: '',
      value: formatCurrency(apiData.forecast, currency),
      // trend: getTrend(forecastVsCurrentPercentage),
      // trendValue: `${Math.abs(forecastVsCurrentPercentage).toFixed(1)}%`,
      icon: 'forecast',
    },
    {
      title: 'Daily Average',
      description: '',
      value: formatCurrency(apiData.dailyAverage, currency),
      // trend: getTrend(avgChangePercentage),
      // trendValue: avgChangePercentage !== 0 ? `${Math.abs(avgChangePercentage).toFixed(1)}%` : undefined,
      icon: 'average',
    },
  ];
};
